import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { APP_CONTAINER_SETTINGS } from '@mydocma/app-container';
import { AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { ConfigProvider } from '@mydocma/common';
import { MYDOCMASETTINGS } from '@mydocma/core';
import { PR_CONFIG, PrConfig } from '../projects/mydocma/pr/src/lib/configuration/pr.config';
import { TASK_CONFIG, WEBSOCKET_CONFIG } from '@mydocma/task';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

async function main() {
  try {
    const configProvider = new ConfigProvider<PrConfig>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([
      { provide: TASK_CONFIG, useValue: config.taskConfig },
      { provide: WEBSOCKET_CONFIG, useValue: config.webSocketConfig },
      { provide: AUTHSETTINGS, useValue: config.authConfig },
      { provide: AUTHSTORAGE, useValue: sessionStorage },
      { provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig },
      { provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig },
      {
        provide: PR_CONFIG,
        useValue: {
          ...config.prConfig,
          parentApp: config.appName,
          appIconColor: config.appIconColor,
        },
      },
    ])
      .bootstrapModule(AppModule)
      .then(() => {});
  } catch (error) {
    console.error(error);
  }
}

main();
